import { defineStore } from 'pinia';
import {
  ref
} from '@nuxtjs/composition-api';


export const usePlayMixStore = defineStore('playMixStore', () => {
  const selectedPlayServices = ref([]);
  const data = ref(null)
  const mixes = {}
  return {
    data,
    selectedPlayServices,
    mixes
  }
})
